import PropTypes from 'prop-types';

import { DownloadIcon } from '@utilities';

const DownloadXLSX = ({ downloadFileUrl, downloadLabel }) => {
  return (
    <a data-log="Flow_Excel_Download" data-testid="download-xlsx" href={downloadFileUrl}>
      <DownloadIcon />
      <span>.XLSX File - {downloadLabel || 'Entire Report'}</span>
    </a>
  );
};

DownloadXLSX.propTypes = {
  downloadFileUrl: PropTypes.string,
  downloadLabel: PropTypes.string,
};

export default DownloadXLSX;
